import { Component, OnInit, OnDestroy } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../shared/services/common.service';
import { EntityService } from '../../services/entity.service';
import { Celebrity } from '../../models/admin.models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoPopupComponent } from '../video-popup/video-popup.component';
import { AppInstallModalComponent } from './app-install-modal/app-install-modal.component';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-explore',
  standalone: true,
  imports: [CarouselModule, CommonModule, AppInstallModalComponent],
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss']
})
export class ExploreComponent implements OnInit, OnDestroy {
  public options = {
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    items: 1
  };

  public images = [
    'assets/images/login/login-1.jpg',
    'assets/images/bg-1.jpg',
    'assets/images/bg-2.jpg'
  ];
  
  // ... reste des propriétés existantes ...
  public blogSection = [
    // ... existing ...
  ]

  public carouselContent = [
    // ... existing ...
  ];

  celebrities: Celebrity[] = [];
  loading = false;

  public currentImageIndex = 0;
  public isTextVisible = true;
  private imageInterval: any;

  public celebritiesOptions = {
    // ... existing ...
  };

  constructor(
    private commonService: CommonService,
    private entityService: EntityService,
    private modalService: NgbModal,
    private seoService: SeoService
  ) {}

  ngOnInit() {
    this.seoService.updateSeo({
      title: 'Explorer les célébrités',
      description: 'Parcourez les profils de vos artistes, influenceurs, sportifs et personnalités publiques préférés. Demandez une vidéo dédicacée personnalisée sur YokaStar.',
      keywords: 'célébrités, artistes, influenceurs, sportifs, vidéos dédicacées, messages personnalisés, YokaStar',
      url: 'https://yokastar.com/explore'
    });
    this.seoService.setStructuredData({
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      'name': 'Explorer les célébrités sur YokaStar',
      'description': 'Parcourez tous les artistes, influenceurs et sportifs disponibles sur YokaStar pour une vidéo dédicacée.',
      'url': 'https://yokastar.com/explore',
      'isPartOf': { '@type': 'WebSite', 'name': 'YokaStar', 'url': 'https://yokastar.com/' }
    });
    this.loadCelebrities();
    this.startImageRotation();
  }

  ngOnDestroy() {
    if (this.imageInterval) {
      clearInterval(this.imageInterval);
    }
    this.seoService.removeStructuredData();
  }

  private startImageRotation() {
    this.imageInterval = setInterval(() => {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
    }, 4000);
  }

  openHowItWorksVideo() {
    const modalRef = this.modalService.open(VideoPopupComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'video-modal-window'
    });
    
    modalRef.componentInstance.videoUrl = 'https://www.youtube.com/watch?v=i51JrQRmbu0'; 
    modalRef.componentInstance.title = 'Comment ça marche ?';
  }

  openAppInstallModal() {
    this.modalService.open(AppInstallModalComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'app-install-modal-window',
      modalDialogClass: 'app-install-modal-dialog'
    });
  }

  scrollToStars(event: Event) {
    // ... existing ...
  }

  private loadCelebrities() {
    // ... existing ...
  }
}
